import { AccrualsSlice } from './accruals-types';
import { FacilitySliceCreator } from './facility-types';

export const createAccrualsSlice: FacilitySliceCreator<AccrualsSlice> = (
  set
) => ({
  accruals: {},

  setAccrualsStartDate: (employeeId: number, startDate: string) =>
    set((state) => ({
      accruals: {
        ...state.accruals,
        [employeeId]: {
          ...state.accruals[employeeId],
          startDate,
        },
      },
    })),

  clearAccruals: () =>
    set({
      accruals: {},
    }),
});
